import React, { useState } from 'react';
import DepartmentSetting from '../../components/DepartmentSetting';
import { useSelector } from 'react-redux';

import { useActions } from 'hooks/useActions';
import * as actions from './actions';
import { OuterContainer, ContainerHeading, DepartmentListContainer, DepartmentHeadingContainer } from './styles';
import { Link } from '../ChallengeListPage/styles';
import { Button } from '../../components';
import AddDepartmentModal from './AddDepartmentModal';

export default function DepartmentSettings({ isDepartmentSettingsPage }) {
  const {
    settings: { departments },
  } = useSelector((state) => state.settings);

  const { updateDepartment, createDepartment } = useActions(actions);
  const [isAddDepartment, setIsAddDepartment] = useState(false);

  const saveDepartment = (department) => {
    createDepartment(department);
    setIsAddDepartment(false);
  };

  const renderDepartmentButtons = () => {
    return (
      <DepartmentListContainer>
        {departments.map((department) => (
          <Link to={`/department-settings/${department._id}`} key={department._id}>
            <Button small primaryBlue primaryGreenBorder usePadding="9px" key={department._id}>
              {department.name}
            </Button>
          </Link>
        ))}
      </DepartmentListContainer>
    );
  };

  return (
    <OuterContainer>
      {isAddDepartment && (
        <AddDepartmentModal closeModal={() => setIsAddDepartment(false)} createDepartment={saveDepartment} />
      )}
      <DepartmentHeadingContainer>
        <ContainerHeading>Department Settings </ContainerHeading>
        {!isDepartmentSettingsPage && (
          <Button small primaryBlue primaryGreenBorder margin="0" onClick={() => setIsAddDepartment(true)}>
            <i className="fa fa-plus mr-2"></i>Add Department
          </Button>
        )}
      </DepartmentHeadingContainer>
      {departments.length === 1 && (
        <DepartmentSetting
          department={departments[0]}
          updateDepartment={(department) => updateDepartment(departments[0]._id, department)}
          isDepartmentSettingsPage={isDepartmentSettingsPage}
        />
      )}
      {departments.length > 1 && renderDepartmentButtons()}
    </OuterContainer>
  );
}
